/**
 * @generated SignedSource<<2dd7710177c6dc608eea574a5f302943>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TalentRole = "COLORIST" | "DIRECTOR" | "DRONE_PILOT" | "EDITOR" | "PHOTOGRAPHER" | "PRODUCER" | "SOUND_ENGINEER" | "VIDEOGRAPHER" | "%future added value";
export type stepsTalentQuery$variables = Record<PropertyKey, never>;
export type stepsTalentQuery$data = {
  readonly talent: ReadonlyArray<{
    readonly headline: string | null | undefined;
    readonly id: string;
    readonly imageUrl: string | null | undefined;
    readonly name: string;
    readonly roles: ReadonlyArray<TalentRole>;
    readonly slug: string;
  }>;
};
export type stepsTalentQuery = {
  response: stepsTalentQuery$data;
  variables: stepsTalentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TalentProfile",
    "kind": "LinkedField",
    "name": "talent",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headline",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roles",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "stepsTalentQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "stepsTalentQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bd338d2d09eefa17c0c5369ec54f0912",
    "id": null,
    "metadata": {},
    "name": "stepsTalentQuery",
    "operationKind": "query",
    "text": "query stepsTalentQuery {\n  talent {\n    id\n    name\n    slug\n    headline\n    roles\n    imageUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f7d2345b511613877c66858a9ca5f59";

export default node;
